export default "<span #currentTime></span>\r\n"